(function () {
  'use strict';

  if (window.__tangibleProductOptionsV7) return;
  window.__tangibleProductOptionsV7 = true;

  var state = {
    selectedSize: '',
    userIntent: false,
    queued: false
  };

  function compact(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function productRoot() {
    var node = document.querySelector('main#MainContent [id^="ProductSection-"]');
    if (node) {
      node.classList.remove('tg-options-v2');
      node.classList.add('tg-options-v3');
    }
    return node;
  }

  function sizeScore(field) {
    if (!field) return 0;
    var legend = compact(field.querySelector('legend') && field.querySelector('legend').textContent);
    if (/\bsize\b/i.test(legend)) return 100;
    var values = Array.prototype.map.call(
      field.querySelectorAll('input.product-form__radio'),
      function (input) { return compact(input.value).toUpperCase(); }
    );
    return values.filter(function (value) {
      return /^(?:XS|S|M|L|XL|XXL|XXXL|[2-6]XL)$/.test(value);
    }).length;
  }

  function sizeFields() {
    return Array.prototype.filter.call(
      document.querySelectorAll('main#MainContent fieldset.product-form__input'),
      function (field) { return sizeScore(field) >= 3; }
    );
  }

  function primaryField() {
    var fields = sizeFields();
    return fields.find(function (field) {
      return field.classList.contains('tg-native-size-option') &&
        !field.classList.contains('mobile');
    }) || fields.find(function (field) {
      return !field.classList.contains('mobile');
    }) || fields[0] || null;
  }

  function selectedInput(field) {
    return field ? field.querySelector('input.product-form__radio:checked') : null;
  }

  function selectedValue(field) {
    var checked = selectedInput(field);
    if (checked) return checked.value;
    var nativeValue = field.querySelector('legend [data-header-option]');
    return nativeValue ? compact(nativeValue.textContent) : '';
  }

  function ensureHeading(field) {
    var heading = field.querySelector(':scope > .tg-size-heading');
    if (!heading) {
      heading = document.createElement('div');
      heading.className = 'tg-size-heading';
      field.insertBefore(heading, field.firstChild);
    }

    var title = heading.querySelector(':scope > .tg-size-title');
    if (!title) {
      title = document.createElement('div');
      title.className = 'tg-size-title';
      title.appendChild(document.createTextNode('Size: '));
      var output = document.createElement('span');
      output.className = 'tg-size-title-value';
      title.appendChild(output);
      heading.insertBefore(title, heading.firstChild);
    }

    var valueNode = title.querySelector('.tg-size-title-value');
    var current = selectedValue(field);
    if (valueNode && compact(valueNode.textContent) !== current) valueNode.textContent = current;

    Array.prototype.slice.call(
      heading.querySelectorAll(':scope > a.tg-size-guide-button, :scope > button.tg-size-guide-button')
    ).forEach(function (node) { node.remove(); });

    return heading;
  }

  function hideLegend(field) {
    var legend = field.querySelector(':scope > legend');
    if (legend) legend.classList.add('tg-native-size-legend');
  }

  function labelFor(field, input) {
    var next = input.nextElementSibling;
    if (next && next.matches('label.product-form__label')) return next;
    if (!input.id) return null;
    return Array.prototype.find.call(
      field.querySelectorAll('label.product-form__label'),
      function (label) { return label.getAttribute('for') === input.id; }
    ) || null;
  }

  function buildGrid(field) {
    var grid = field.querySelector(':scope > .tg-size-grid');
    if (!grid) {
      grid = document.createElement('div');
      grid.className = 'tg-size-grid';
    }

    var inputs = Array.prototype.slice.call(field.querySelectorAll(':scope > input.product-form__radio'));
    if (!inputs.length) {
      inputs = Array.prototype.slice.call(field.querySelectorAll('.tg-size-grid > input.product-form__radio'));
    }

    inputs.forEach(function (input) {
      var label = labelFor(field, input);
      if (!label) return;
      if (input.parentNode !== grid) grid.appendChild(input);
      if (label.parentNode !== grid) grid.appendChild(label);
    });

    if (grid.children.length && !grid.parentNode) field.appendChild(grid);
    field.classList.add('tg-size-structured');
  }

  function purgePrompt(field) {
    var wrapper = field.closest('.productView-moreItem-product-variant') || field.parentElement;
    if (!wrapper) return;

    var walker = document.createTreeWalker(wrapper, NodeFilter.SHOW_TEXT);
    var nodes = [];
    var node;
    while ((node = walker.nextNode())) nodes.push(node);

    nodes.forEach(function (textNode) {
      var parent = textNode.parentElement;
      if (!parent || parent.closest('.tg-size-heading, legend, label, button, a, option, script, style')) return;
      if (/^\s*select\s+size\s*:?\s*$/i.test(textNode.nodeValue || '')) {
        textNode.nodeValue = '';
        parent.setAttribute('data-tg-size-prompt', 'hidden');
      }
    });

    wrapper.querySelectorAll('span, div, p, strong, small').forEach(function (element) {
      if (element.closest('.tg-size-heading, legend, label, button, a') ||
          element.querySelector('input, select, option, button, a, label')) return;
      if (/^select\s+size\s*:?$/i.test(compact(element.textContent))) {
        element.setAttribute('data-tg-size-prompt', 'hidden');
      }
    });
  }

  function setNativeHeading(field, value) {
    var nativeValue = field && field.querySelector('legend [data-header-option]');
    if (nativeValue && compact(nativeValue.textContent) !== value) nativeValue.textContent = value;
  }

  function renderHeading(field, value) {
    if (!field) return;
    setNativeHeading(field, value);

    var title = field.querySelector(':scope > .tg-size-heading .tg-size-title');
    if (!title) return;

    var output = title.querySelector('.tg-size-title-value');
    var first = title.firstChild;
    var prefix = value ? 'Size: ' : 'Size';

    if (!first || first.nodeType !== 3) {
      first = document.createTextNode(prefix);
      title.insertBefore(first, title.firstChild);
    } else if (first.nodeValue !== prefix) {
      first.nodeValue = prefix;
    }

    if (output && compact(output.textContent) !== value) output.textContent = value;
  }

  function renderAllHeadings(value) {
    sizeFields().forEach(function (field) { renderHeading(field, value); });
  }

  function clearDefaultSelections() {
    if (state.selectedSize) return;
    sizeFields().forEach(function (field) {
      field.querySelectorAll('input.product-form__radio:checked').forEach(function (input) {
        input.checked = false;
        input.removeAttribute('checked');
      });
      renderHeading(field, '');
    });
  }

  function errorNode(field) {
    if (!field) return null;
    var error = field.querySelector(':scope > .tg-size-required-error');
    if (error) return error;

    error = document.createElement('p');
    error.className = 'tg-size-required-error';
    error.id = 'tg-size-required-error';
    error.setAttribute('role', 'alert');
    error.hidden = true;
    error.innerHTML = '<span class="tg-size-required-error__icon" aria-hidden="true">!</span><span>Please select a size to continue.</span>';
    field.appendChild(error);
    return error;
  }

  function clearError() {
    var field = primaryField();
    if (!field) return;
    var error = errorNode(field);
    field.classList.remove('tg-size-required-invalid');
    field.removeAttribute('aria-invalid');
    field.removeAttribute('aria-describedby');
    if (error) error.hidden = true;
  }

  function showError() {
    var field = primaryField();
    if (!field) return;
    var error = errorNode(field);
    field.classList.add('tg-size-required-field', 'tg-size-required-invalid');
    field.setAttribute('aria-invalid', 'true');
    field.setAttribute('aria-describedby', error.id);
    error.hidden = false;
    field.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function syncFields(value) {
    sizeFields().forEach(function (field) {
      field.querySelectorAll('input.product-form__radio').forEach(function (input) {
        input.checked = compact(input.value) === value;
      });
      renderHeading(field, value);
    });
  }

  function acceptSelection(input) {
    var value = compact(input && input.value);
    if (!value) return;
    state.selectedSize = value;
    syncFields(value);
    clearError();
    document.body.setAttribute('data-tg-selected-size', value);
  }

  function inputForLabel(label) {
    if (!label) return null;
    var id = label.htmlFor || label.getAttribute('for');
    if (!id) return null;
    var input = document.getElementById(id);
    return input && input.matches('input.product-form__radio') ? input : null;
  }

  function isPrimaryPurchaseControl(node) {
    if (!node || !node.closest) return null;
    var control = node.closest([
      'button.product-form__submit',
      'button[name="add"]',
      '.shopify-payment-button__button--unbranded',
      '[data-shopify="payment-button"] button',
      'button[data-btn-addtocart]',
      'button[data-btn-addToCart]'
    ].join(','));
    if (!control || control.closest('.tangible-qa-v2-modal')) return null;
    return control.closest('.productView, [id^="ProductSection-"], .productView-stickyCart') ? control : null;
  }

  function onWindowClick(event) {
    if (!document.body.classList.contains('template-product')) return;

    var label = event.target && event.target.closest &&
      event.target.closest('fieldset.product-form__input label.product-form__label');
    var input = inputForLabel(label);

    if (input && sizeScore(input.closest('fieldset')) >= 3 && !input.disabled) {
      state.userIntent = true;
      window.setTimeout(function () { state.userIntent = false; }, 0);

      var field = input.closest('fieldset');
      if (label.closest('.tg-size-grid')) {
        event.preventDefault();
        if (!input.checked) input.checked = true;
        acceptSelection(input);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    var purchase = isPrimaryPurchaseControl(event.target);
    if (!purchase || state.selectedSize) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    showError();
  }

  function onChange(event) {
    var input = event.target;
    if (!input || !input.matches('input.product-form__radio')) return;
    if (sizeScore(input.closest('fieldset')) < 3) return;
    if (state.userIntent || event.isTrusted) acceptSelection(input);
  }

  function onSubmit(event) {
    var form = event.target;
    if (!form || !form.matches('form')) return;
    if (!form.closest('.productView, [id^="ProductSection-"], .productView-stickyCart')) return;
    if (state.selectedSize) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    showError();
  }

  function prepareField(field) {
    field.classList.add('tg-native-size-option', 'tg-size-required-field');
    field.setAttribute('data-tg-native-size', 'true');
    hideLegend(field);
    ensureHeading(field);
    buildGrid(field);
    purgePrompt(field);
  }

  function run() {
    if (!document.body || !document.body.classList.contains('template-product')) return;
    productRoot();

    var fields = sizeFields();
    if (!fields.length) return;
    prepareField(fields[0]);

    var field = primaryField();
    errorNode(field);
    if (state.selectedSize) renderAllHeadings(state.selectedSize);
    else clearDefaultSelections();
  }

  function schedule() {
    if (state.queued) return;
    state.queued = true;
    window.requestAnimationFrame(function () {
      state.queued = false;
      run();
    });
  }

  function start() {
    run();
    [100, 350, 900, 1600].forEach(function (delay) {
      window.setTimeout(run, delay);
    });
  }

  window.addEventListener('click', onWindowClick, true);
  window.addEventListener('submit', onSubmit, true);
  document.addEventListener('change', onChange, true);
  document.addEventListener('shopify:section:load', function () {
    state.selectedSize = '';
    document.body.removeAttribute('data-tg-selected-size');
    window.setTimeout(run, 50);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
